/* eslint-disable react/prop-types, prefer-template, no-param-reassign */
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import classnames from 'classnames';
import { COLUMN_SPACING } from 'es6/core/styles/sizes';
import { optionalOneOf } from 'es6/helpers/prop-types';


const SPANS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

// Gives a column with a width in a grid units (up to 12 which means
// it takes whole page)

export default function Column({ span = 1, children }) {
  return (
    <section className={classnames(css(styles.column), css(styles['span-' + span]))}>
      {children}
    </section>
  );
}

Column.propTypes = {
  span: optionalOneOf(SPANS),
};

const styles = StyleSheet.create(SPANS.reduce(function (sheet, span) {
  sheet['span-' + span] = {
    width: (100 * span / 12) + '%',
  };

  return sheet;
}, {
  column: {
    display: 'block',
    boxSizing: 'border-box',
    paddingLeft: (COLUMN_SPACING / 2) + 'px',
    paddingRight: (COLUMN_SPACING / 2) + 'px',
  },
}));
